import { Button, Col, Form, Input } from 'antd'

import { FEATURE } from 'constants/feature'
import useEditPTOV3 from 'hooks/pto-v3/use-edit-pto-v3'
import { usePermission } from 'hooks/use-permission'
import BaseInformation from 'modules/pto-v3/form/base-information'
import CoTrustedPartners from 'modules/pto-v3/form/co-trusted-partners'
import Properties from 'modules/pto-v3/form/properties'
import UploadFile from 'modules/pto-v3/form/upload-file'

/**
 * PTO v3 - Details tab. Same as v2 with the v3 Basic Information
 * (Token Symbol read-only, OnchainID, no Royalty) and without metadata / golden tickets.
 */
const Information = () => {
  const [form] = Form.useForm()

  const {
    edit,
    thumbnail,
    setThumbnail,
    thumbnails,
    setThumbnails,
    defaultPropertyType,
    propertyTypes,
    switchChecked,
    setSwitchChecked,
    ptoDetail,
    code,
    handleSubmit,
    handleCancel,
    handleEdit,
  } = useEditPTOV3({ form })

  const { canCRUD } = usePermission()
  const canEdit = canCRUD(FEATURE.PTO)

  return (
    <div className="p2p-create">
      <Form
        form={form}
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={handleSubmit}
        scrollToFirstError={{
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        }}
      >
        <Col style={{ display: 'none' }} span={12}>
          <Form.Item
            label="Code"
            name="code"
            rules={[{ required: true, message: 'Please input the code!' }]}
          >
            <Input disabled placeholder="Enter the code" />
          </Form.Item>
        </Col>
        <div style={{ textAlign: 'start', paddingBottom: 10 }}>
          {!edit ? (
            canEdit ? (
              <Button
                style={{ marginRight: 15, width: 100 }}
                key="edit"
                onClick={handleEdit}
                type="primary"
              >
                Edit
              </Button>
            ) : null
          ) : (
            <>
              <Button style={{ marginRight: 15, width: 100 }} key="back" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                style={{ width: 100 }}
                disabled={thumbnail.length === 0 || thumbnails.length === 0}
                key="submit"
                type="primary"
                htmlType="submit"
              >
                Save
              </Button>
            </>
          )}
        </div>

        <BaseInformation
          id={code}
          form={form}
          edit={edit}
          switchChecked={switchChecked}
          setSwitchChecked={setSwitchChecked}
          sellingStatus={ptoDetail?.sellingStatus}
          mode={'edit'}
        />

        <Properties
          form={form}
          edit={edit}
          propertyTypes={propertyTypes}
          defaultPropertyType={defaultPropertyType}
          mode={'edit'}
        />

        <UploadFile
          edit={edit}
          form={form}
          defaultThumbnail={thumbnail}
          defaultThumbnails={thumbnails}
          mode={'edit'}
          onUpload={(data) => {
            setThumbnail(data)
          }}
          onUploadMulti={(data) => {
            setThumbnails(data)
          }}
        />

        <CoTrustedPartners form={form} edit={edit} mode={'edit'} />
      </Form>
    </div>
  )
}

export default Information
